<template>
  <BaseBreadcrumbs
    class="breadcrumbs"
    :text-override="textOverride"
    capitalize-each-word
  />
</template>

<script lang="ts" setup>
interface Props {
  textOverride?: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.breadcrumbs {
  font-size: var(--font-size-paragraph-s) !important;
  font-weight: var(--font-weight-normal) !important;
  letter-spacing: var(--letter-spacing-paragraph-s) !important;
  text-transform: none !important;
  margin-bottom: 36px !important;
  margin-top: 28px;

  @media (min-width: $breakpoint-md) {
    margin-bottom: 52px !important;
    margin-top: 36px;
  }
}
</style>
